'use client';

import { ElementProps } from '@/components/sections/builder/types';
import { cn } from '@/lib/utils';
import { ElementDataType } from '@/components/sections/builder/elements/body/content-pages/type';
import { RichTextEditor } from '@/components/commons/minimal-tiptap';
import { BaseCustomPage } from '@/types/http/custom-pages/common';

export default function ElementContent({ element, data }: ElementProps) {
  const content = element.data as ElementDataType;
  const pages = data as BaseCustomPage;

  return (
    <>
      <section className={cn('bg_content_pages')}>
        <div className='theme_layout_page_width content_pages_wrapper mx-auto duration-100'>
          <div className='theme_layout_space_section'>
            <div className='relative px-6 py-6 lg:px-6 lg:py-8'>
              <h1 className='theme_font_heading mb-10 text-3xl font-semibold md:text-5xl lg:text-6xl xl:text-7xl'>
                {pages?.title}
              </h1>
              <RichTextEditor
                content={pages?.content || ''}
                editable={false}
                editorProps={{
                  attributes: {
                    class: 'prose lg:prose-lg prose-blue dark:prose-invert',
                  },
                }}
              />
            </div>
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .content_pages_wrapper {
            padding-top: ${content.padding?.top}px;
            padding-bottom: ${content.padding?.bottom}px;
            padding-left: ${content.padding?.left}px;
            padding-right: ${content.padding?.right}px;
          }
          .bg_content_pages {
            background-color: ${content.colorSchemeCompanyContent?.background || 'white'};
            color: ${content.colorSchemeCompanyContent?.text || '#52535B'} !important;
          }
        `}
      </style>
    </>
  );
}
